import React, { useContext, useState } from "react";
import { SortingRule } from "react-table";

interface ISchoolTableContext {
  searchValue?: string;
  setSearchValue: React.Dispatch<React.SetStateAction<string | undefined>>;
  sortBy: SortingRule<any>[];
  setSortBy: React.Dispatch<React.SetStateAction<SortingRule<any>[]>>;
  pageIndex: number;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
}

export const SchoolTableContext = React.createContext<ISchoolTableContext>({
  searchValue: "",
  setSearchValue: () => null,
  sortBy: [],
  setSortBy: () => null,
  pageIndex: 0,
  setPageIndex: () => null,
});

interface Props {
  children: React.ReactNode;
}

const SchoolTableProvider = ({ children }: Props) => {
  const [searchValue, setSearchValue] = useState<string>();
  const [sortBy, setSortBy] = useState<SortingRule<any>[]>([{ id: "schoolName", desc: false }]);
  const [pageIndex, setPageIndex] = useState(0);

  return (
    <SchoolTableContext.Provider
      value={{
        searchValue,
        setSearchValue,
        sortBy,
        setSortBy,
        pageIndex,
        setPageIndex,
      }}
    >
      {children}
    </SchoolTableContext.Provider>
  );
};

export default SchoolTableProvider;

export const useSchoolTable = () => {
  const helpers = useContext(SchoolTableContext);

  return helpers;
};

export const useSchoolTableSearch = () => {
  const { searchValue, setSearchValue } = useContext(SchoolTableContext);

  return { searchValue, setSearchValue };
};
